import { CommonModule } from '@angular/common'
import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { LocalChannel } from '../../interfaces/local-channel'
import { ChannelGridWidget } from 'htv-lib'
import { ChannelService } from '../../services/channel.service'
import { BaseWidgetComponent } from '../base-widget/base-widget.component'
import { PAGE_KEY } from '../../constants/page.constants'
import { HTVPlatform } from '../../platforms/platform'
import { PlatformService } from '../../platforms/platform.service'

@Component({
  selector: 'app-channel-grid',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './channel-grid.component.html',
  styleUrls: ['./channel-grid.component.scss'],
})
export class ChannelGridComponent extends BaseWidgetComponent implements OnInit, AfterViewInit {
  channels!: LocalChannel[]
  selectedChannel?: LocalChannel

  platformType!: HTVPlatform
  HTVPlatform = HTVPlatform

  private mutationObserver?: MutationObserver

  constructor(
    private channelService: ChannelService,
    private platformService: PlatformService,
    private chRef: ChangeDetectorRef
  ) {
    super()
  }

  override ngOnInit(): void {
    super.ngOnInit()
    this.platformType = this.platformService.type
    this.channels = this.channelService.channels
  }

  ngAfterViewInit(): void {
    // This works, but seems unnecessary
    if (this.platformType == HTVPlatform.PHILIPS) {
      this.mutationObserver = new MutationObserver(() => {
        const selectedCard = this.el.nativeElement.querySelector('.channel-card.htv-selected')
        if (selectedCard) {
          const allChannelCards = Array.from(this.el.nativeElement.querySelectorAll('.channel-card.htv-selectable'))
          const index = allChannelCards.indexOf(selectedCard)
          if (index !== -1 && this.channels[index]) {
            this.focusChannel(this.channels[index])
          }
        }
      })

      this.mutationObserver.observe(this.el.nativeElement, {
        subtree: true,
        attributeFilter: ['class'],
      })
    }
  }

  override applyStyles(): void {
    super.applyStyles()

    const config = this.config as ChannelGridWidget
    const itemStyle: Record<string, string | number> = {}
    const itemFocusStyle: Record<string, string | number> = {}

    if (config.nbColumns) {
      itemStyle['width'] = `${100 / (config.nbColumns ?? 4)}%`
    }

    if (config.nbLines) {
      itemStyle['height'] = `${100 / (config.nbLines ?? 4)}%`
    }

    if (config.gap) {
      itemStyle['padding'] = `${this.scaleToResolution(config.gap / 2)}px`
    }

    if (config.itemBackgroundColor) {
      itemStyle['background-color'] = config.itemBackgroundColor
    }

    if (config.focusBorderSize) {
      itemFocusStyle['border-width'] = `${this.scaleToResolution(config.focusBorderSize)}px`
    }

    if (config.focusBorderColor) {
      itemFocusStyle['border-color'] = config.focusBorderColor
    }

    if (config.focusBackgroundColor) {
      itemFocusStyle['background-color'] = config.focusBackgroundColor
    }

    this.setRule('.item', itemStyle)
    this.setRule('.item.htv-selected .item__inner', itemFocusStyle)
  }

  focusChannel(channel: LocalChannel): void {
    if (this.selectedChannel?.id === channel.id && this.platformType == HTVPlatform.PHILIPS) return
    this.selectedChannel = channel
    this.chRef.detectChanges()
    this.channelService.selectChannel(channel)
    this.pageService.updateSubject(PAGE_KEY.SELECTED_CHANNEL, this.selectedChannel)
  }

  openChannel(): void {
    if (this.selectedChannel) {
      this.channelService.openChannelPage(this.selectedChannel)
    }
  }
}
